// extracted by mini-css-extract-plugin
export var label = "_bz-5";
export var slideContainer = "_bz-0";
export var slider = "_bz-1";
export var sliderLg = "_bz-4";
export var sliderMd = "_bz-3";
export var sliderSm = "_bz-2";